import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import { useBasicPopoverPositioning } from '../hooks/useBasicPopoverPositioning';
import { usePortalNode } from '../hooks/usePortalNode';
var BasicPositionedPopover = function (_a) {
    var children = _a.children, renderPopover = _a.renderPopover, className = _a.className, placement = _a.placement, secondaryPlacement = _a.secondaryPlacement, _b = _a.isVisible, isVisible = _b === void 0 ? true : _b;
    var portalContainer = usePortalNode();
    var _c = useState(null), contentNode = _c[0], setContentNode = _c[1];
    var _d = useState(null), tooltipNode = _d[0], setTooltipNode = _d[1];
    useBasicPopoverPositioning(contentNode, tooltipNode, {
        placement: placement,
        secondaryPlacement: secondaryPlacement,
        enabled: isVisible,
    });
    return (React.createElement("div", { className: className, ref: setContentNode },
        children,
        portalContainer &&
            isVisible &&
            ReactDOM.createPortal(renderPopover({ ref: setTooltipNode }), portalContainer)));
};
BasicPositionedPopover.displayName = 'BasicPositionedPopover';
export default BasicPositionedPopover;
//# sourceMappingURL=BasicPositionedPopover.js.map